// extracted by mini-css-extract-plugin
export default {"component":"BonusMain__component--lc-eomYf","section":"BonusMain__section--lc-_EebY"};